define('adminNotificationsView',[
  'module',
  'underscore',
  'app',
  'settings',
  'backbone',
  'tableView',
  'tableDatetimeFieldView',
  'adminNotificationsCreatorView',
  'adminNotificationsModificationView',
  'adminNotificationsInfosView',
  'adminNotificationsToolsView',
  'adminNotificationsListHeaderToolsView',
  'adminNotificationsFiltersView',
  'entities/admin/notifications'
], function (
    Module,
    _,
    App,
    Settings,
    Backbone,
    TableView,
    DatetimeFieldView,
    CreatorView,
    ModificationView,
    InfosView,
    ToolsView,
    PreferencesView,
    FiltersView
) {
  'use strict';

  Module.exports = TableView.extend({

    className: 'admin-notifications-view table-view',
    pageSize: 50,
    //defaultSortField: 'Date',
    //defaultSortDirection: 'desc',
    pageMode: 'pagination',
    filtersViewClass: FiltersView,

    setFields: function() {
      return [{
        name: 'Creator',
        label: _.i18n('notifications.creator'),
        className: 'creator',
        view: CreatorView,
        showName: true
      }, {
        name: 'Date',
        label: _.i18n('notifications.date'),
        bind: 'creatDate',
        className: 'date',
        view: DatetimeFieldView
      }, {
        name: 'Infos',
        label: _.i18n('notifications.context'),
        className: 'infos',
        view: InfosView
      }, {
        name: 'Modification',
        label: _.i18n('notifications.modification'),
        className: 'modification',
        view: ModificationView
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: ToolsView
      }, {
        name: 'headerTools',
        className: 'header-tools',
        headerView: PreferencesView,
        showBody: false
      }];
    },

    fetch: function(first, pageSize, sortField, sortDirection, filters) {

      var defer = $.Deferred();

      var params = this.getFiltersParams(filters);
      params.pageSize = pageSize;
      params.first = first;
      params._search = 'false';

      if (sortField !== '') {
        var sortParamName = '';
        if (sortField === 'Date')
          sortParamName = 'notification.creatDate';

        if (sortParamName !== '') {
          params.sidx = sortParamName;
          params.sord = sortDirection;
        }
      }

      var url = App.request('notifications:get-url', params);

      //console.log('Fetching notification from URL: ', url);

      $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (items) {
          var models = [];

          _.each(items, _.bind(function(item) {
            var model = App.request('notifications:model', item);
            models.push(model);
          }, this));

          defer.resolve(models);
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function(filters) {
      var defer = $.Deferred();

      if(this.fetchCountRequest)
        this.fetchCountRequest.abort();

      var params = this.getFiltersParams(filters);

      $.ajax({
        url: Settings.url('compuzz2', 'v2/usernotifications/rowCount', params),
        success: function (resp) {
          defer.resolve(resp);
        }
      });

      return defer.promise();
    },

    getFiltersParams: function(filters) {
      var params = {};

      _.each(filters.attributes, function (value, key) {
        if(key !== 'dateFrom' && key !== 'dateTo') {
          if(value !== '')
            params[key] = value;
        }
      }, this);

      if(filters.get('dateFrom') !== '' && filters.get('dateTo') !== '') {
        params.dateFrom = filters.get('dateFrom');
        params.dateTo = filters.get('dateTo');
      }

      return params;
    }
  });
});
